<template>
  <van-popup v-model="show" style="width: 100%" round closeable :close-on-click-overlay="false" position="bottom" @close="close">
    <div style="padding: 20px">
      <div v-if="step===0">
        <div style="display: flex;align-items: center" @click="ask(0) ">
          <img src="@/assets/img/generate_by_ai.png" style="width: 60px;height: 60px"/>
          <div style="display: flex;flex-direction: column;margin-left: 6px">
            <div style="font-size: 18px;font-weight: 600">智能推荐</div>
            <div style="font-size: 14px;padding-top: 4px">由智能AI助手为您推荐内容</div>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px" @click="ask(1)">
          <img src="@/assets/img/generate_by_history.png" style="width: 60px;height: 60px"/>
          <div style="display: flex;flex-direction: column;margin-left: 6px">
            <div style="font-size: 18px;font-weight: 600">历史推荐</div>
            <div style="font-size: 14px;padding-top: 4px">根据系统历史数据推荐内容</div>
          </div>
        </div>
      </div>
      <div v-if="step===1">
        <div v-if="type===0" style="font-size: 14px">以下内容由AI生成，仅供参考。</div>
        <div v-if="type===1" style="font-size: 14px">以下内容由系统推荐，仅供参考。</div>
        <div style="position: relative">
          <van-field
            v-model="content"
            rows="6"
            clickable
            :autosize="{ maxHeight: 500, minHeight:100 }"
            type="textarea"
            placeholder=""
            style="margin: 10px 0;border: 1px solid #eeeeee;border-radius: 6px;padding: 6px;height: 50%"
          />
          <div v-if="loading" style="position: absolute;top: 2px;left: 12px;display: flex;align-items: center">
            <div style="color: #666666;font-size: 14px">生成中</div>
            <img src="@/assets/img/ai_loading.gif" style="width: 26px;height: 26px;padding-left: 4px"/>
          </div>
        </div>

        <div style="display: flex;">
          <div style="flex: 1"></div>
          <div class="reset" @click="ask(type)">重新生成</div>
          <div class="insert" @click="insert">插入</div>
        </div>
      </div>

    </div>
  </van-popup>
</template>

<script>
import md5 from 'md5'
import {AimiMixin} from "@/mixins/AimiMixin";

export default {
  name: "login",
  mixins: [AimiMixin],
  data() {
    return {
      show: false,
      step: 0,
      type: '',//0:AI生成，1：历史推荐
      content: '',
      loading: false
    };
  },
  computed: {
    showAIPopup:{
      get(){
        return this.$store.state.common.showAIPopup;
      },
      set(v) { }
    }
  },
  watch: {
    showAIPopup(val) {
      this.show = val.state
    }
  },
  methods: {
    ask(type) {
      this.step = 1
      this.type = type
      this.content = ''
      this.loading = true
      switch (type) {
        case 0:
          this.generateByAI()
          break;
        case 1:
          this.generateBySystem()
      }
    },
    close() {
      this.show = false
      this.step = 0
      this.type = ''
      this.content = ''
      this.loading = false
      this.$store.commit('SHOW_AI_POPUP', {
        state: false,
        pojo: '',
        field: '',
        question: '',
      })
    },
    generateByAI() {
      this.$store.dispatch("server", {
        type: "get",
        url: '/socialworker/bigModel',
        token: this.token,
        data: this.showAIPopup,
      }).then((response) => {
        if (response.data.status === 200) {
          this.content = response.data.data
          this.loading = false
          console.log('获取AI的回答\n字段：' + this.showAIPopup.field + '\n内容：\n' + this.content)
        } else {
          this.$toast(response.data.msg);
        }
      })
    },
    generateBySystem() {
      this.$store.dispatch("server", {
        type: "get",
        url: '/socialworker/bigModel/historyRecommend',
        token: this.token,
        data: this.showAIPopup,
      }).then((response) => {
        if (response.data.status === 200) {
          this.content = response.data.data
          this.loading = false
        } else {
          this.$toast(response.data.msg);
        }
      })
    },
    insert() {
      this.$store.commit("CONTENT_BY_AI", {
        content: this.content,
        field: this.showAIPopup.field,
      });
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
> > > .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
  font-size: 22px;
}

> > > .van-field__control {
  font-size: 16px;
  padding-left: 5px;
  margin-top: 2px;
}

.insert {
  background: #F5FFF1;
  border-radius: 15px;
  border: 1px solid #C1F1BC;
  color: #24BE48;
  padding: 4px 15px;
  font-size: 16px;
  font-weight: 400;
}

.reset {
  background: #FFFFFF;
  border-radius: 15px;
  border: 1px solid #EAEAEA;
  margin-left: 12px;
  padding: 4px 15px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/AIPopup/index.vue